module.exports = __webpack_public_path__ + "img/ring_y_o_0_null.b761b52c.png";